import { SvgIcon } from '@mui/material';

export const ChatUsersIcon = () => {
  return (
    <SvgIcon
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_352_27223)">
        <path
          opacity="0.2"
          d="M9.625 17.5C12.7661 17.5 15.3125 14.9536 15.3125 11.8125C15.3125 8.67138 12.7661 6.125 9.625 6.125C6.48388 6.125 3.9375 8.67138 3.9375 11.8125C3.9375 14.9536 6.48388 17.5 9.625 17.5Z"
          fill="white"
        />
        <path
          d="M9.625 17.5C12.7661 17.5 15.3125 14.9536 15.3125 11.8125C15.3125 8.67138 12.7661 6.125 9.625 6.125C6.48388 6.125 3.9375 8.67138 3.9375 11.8125C3.9375 14.9536 6.48388 17.5 9.625 17.5Z"
          stroke="white"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M16.9971 6.33281C17.4998 6.19645 18.0183 6.12659 18.5393 6.125C20.0477 6.125 21.4943 6.72422 22.5609 7.79083C23.6275 8.85744 24.2268 10.3041 24.2268 11.8125C24.2268 13.3209 23.6275 14.7676 22.5609 15.8342C21.4943 16.9008 20.0477 17.5 18.5393 17.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.75 21.5906C2.63807 20.3269 3.81723 19.2955 5.18788 18.5834C6.55854 17.8714 8.08043 17.4996 9.625 17.4996C11.1696 17.4996 12.6915 17.8714 14.0621 18.5834C15.4328 19.2955 16.6119 20.3269 17.5 21.5906"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5391 17.5C20.0838 17.499 21.606 17.8703 22.9768 18.5824C24.3476 19.2944 25.5266 20.3263 26.4141 21.5906"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_352_27223">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
